import { createAsyncThunk } from '@reduxjs/toolkit';
import { getClientPortalChatMessages } from 'services/pod';
import { IClientPortalChatMessage } from 'services/pod/types';

interface IProps {
  chatId: number;
}

export const ThunkGetClientPortalChatMessages = createAsyncThunk<
  IClientPortalChatMessage[],
  IProps
>('clientPortalChats/getClientPortalChatMessages', async ({ chatId }) => {
  const r = await getClientPortalChatMessages(chatId);
  return r.data;
});
